import React from "react";
import { useEffect, useState } from "react";

import { useOutletContext } from "react-router";
import {
	PaginationProps,
} from "antd";
import {
	getBatchJobResultSheetTitle,
	getBatchJobsData,
	SETTINGS_DATA,
	updateUserPageSizeSettings,
} from "../../utils";
import BatchJobActionComponent from "../batch_job_action_component";
import { TablePaginationConfig } from "antd/lib/table/interface";
import { FileInfo } from "../types";
import { JobDetailsColumn } from "../components/JobDetailsColumn";
import { ResultsColumn } from "../components/ResultsColumn";

export const initialPaginationObj: TablePaginationConfig = {
	current: 1,
	pageSize: 10,
	position: ["bottomRight"],
	hideOnSinglePage: false,
	showSizeChanger: true,
	pageSizeOptions: [10, 20],
};
export const useBatchJobsHook = () => {
	const { user, setUser }: any = useOutletContext();

	const [batchJobsData, setBatchJobsData] = useState([]);
	const [currentSheetMetaData, setCurrentSheetMetaData] = useState<any>({});
	const [allSheetsMetaData, setAllSheetsMetaData] = useState<any>({});
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [pagination, setPagination] = useState<PaginationProps>({
		...initialPaginationObj,
		pageSize: user.page_sizes?.batch_jobs ?? 10,
		// pageSize: 10,
	});

	const [isModalVisible, setIsModalVisible] = useState(false);
	const [modalRows, setModalRows] = useState<any[]>([]);
	const [modalTitle, setModalTitle] = useState("Unfilled Time");
	const [, setModalBatchJobId] = useState("");

	// State for file loading and errors per job
	const [fileInfoByJobId, setFileInfoByJobId] = useState<{ [jobId: string]: { file1: FileInfo; file2: FileInfo | null } }>({});

	const handleModalOk = () => {
		setIsModalVisible(false);
	};

	const handleModalCancel = () => {
		setIsModalVisible(false);
	};


	useEffect(() => {
		// set allSheetsMetaData from batchJobsData.spread_sheet_id and spread_sheet_title
		const newSheetsMetaData: any = {};
		batchJobsData.forEach((job: any) => {
			if (job.spread_sheet_id && job.spread_sheet_title) {
				newSheetsMetaData[job.spread_sheet_id] = {
					title: job.spread_sheet_title,
					spreadSheetId: job.spread_sheet_id,
				};
			}
		});
		console.log("Setting allSheetsMetaData", newSheetsMetaData);
		setAllSheetsMetaData(newSheetsMetaData);
	}, [ batchJobsData ]);

	useEffect(() => {
		console.log("useBatchJobsHook useEffect", pagination.pageSize, pagination.current);
		setIsLoading(true);
		getDataHanlder();
	}, [pagination.current, pagination.pageSize]);

	useEffect(() => {
		console.log("useBatchJobsHook useEffect for currentSheetMetaData", currentSheetMetaData);
		if (currentSheetMetaData && currentSheetMetaData.spreadSheetId) {
			console.log(
				"Setting currentSheetMetaData for spreadSheetId:",
				currentSheetMetaData.spreadSheetId
			);
			setAllSheetsMetaData({
				...allSheetsMetaData,
				[currentSheetMetaData.spreadSheetId]: currentSheetMetaData,
			});
		}
	}, [currentSheetMetaData]);

	const handleTableChange = (pagination: PaginationProps, _: any, sorter: any, { action }: any) => {
		switch (action) {
			case "paginate": {
				if (pagination.pageSize !== user.page_sizes.metadata) {
					const updatedSettingsData: SETTINGS_DATA = {
						user_id: user.user_id,
						page_sizes: { ...user.page_sizes, batch_jobs: pagination.pageSize },
					};
					updateUserPageSizeSettings(updatedSettingsData);
					setUser({ ...user, ...updatedSettingsData });
				}
				setPagination(pagination);
				break;
			}
		}
	};


	const getDataHanlder = async () => {
		await getBatchJobsData(setBatchJobsData, setIsLoading, setPagination, pagination);
	};

	const getColumnsBatchJobs = () => {
		const columnBatchJobs = [
			{
				title: "Job Details",
				dataIndex: "job_details",
				key: "job_details",
				width: "30%",
				render: (_: any, record: any) => (
					<JobDetailsColumn
						record={record}
						fileInfoByJobId={fileInfoByJobId}
						setFileInfoByJobId={setFileInfoByJobId}
						allSheetsMetaData={allSheetsMetaData}
						onGetBatchJobResultSheetTitle={getBatchJobResultSheetTitle}
						setIsLoading={setIsLoading}
						setCurrentSheetMetaData={setCurrentSheetMetaData}
					/>
				),
			},
			{
				title: "Results",
				dataIndex: "job_result_json",
				key: "details",
				width: "45%",
				render: (json_string: any, record: any) => (
					<ResultsColumn
						json_string={json_string || ""}
						record={record}
						modalTitle={modalTitle}
						modalRows={modalRows}
						isModalVisible={isModalVisible}
						onModalOk={handleModalOk}
						onModalCancel={handleModalCancel}
						onSetModalBatchJobId={setModalBatchJobId}
						onSetModalTitle={setModalTitle}
						onSetModalRows={setModalRows}
						onSetIsModalVisible={setIsModalVisible}
					/>				),
			},
			{
				title: "",
				dataIndex: "action",
				key: "action",
				render: (text: any, record: any) => {
					return <BatchJobActionComponent record={record} setIsLoading={setIsLoading} onRefresh={refreshBatchJobs} />;
				},
			},
		];

		return columnBatchJobs;
	};

	const refreshBatchJobs = async () => {
		await getDataHanlder();
	};

	return { getColumnsBatchJobs, batchJobsData, isLoading, pagination, handleTableChange, refreshBatchJobs };
};
